export function zoom(event){
    if (event) {
        const zoomer = event.currentTarget;
        let multiplier = parseInt(zoomer.dataset.zoom) || 0; // Default to 1 if not set
        zoomer.style.backgroundRepeat = 'no-repeat';

        function initZoom() {
            if (multiplier === 0) {
                zoomer.style.backgroundSize = 'contain';
                zoomer.style.backgroundPosition = 'center';
                zoomer.style.cursor = 'zoom-in';
            } else {
                const offsetX = event.offsetX ? event.offsetX : event.touches[0].pageX;
                const offsetY = event.offsetY ? event.offsetY : event.touches[0].pageY;
                const x = (offsetX / zoomer.offsetWidth) * 100;
                const y = (offsetY / zoomer.offsetHeight) * 100;
                if (multiplier === 1) {
                    zoomer.style.backgroundSize = '150%';
                } else {
                    zoomer.style.backgroundSize = '200%';
                }
                zoomer.style.backgroundPosition = x + '% ' + y + '%';
            }
        }
        initZoom();

        zoomer.onclick = () => {
            if (multiplier === 1) {
                multiplier = 2;
            } else if (multiplier === 2) {
                multiplier = 0;
            } else {
                multiplier = 1;
            }
            zoomer.dataset.zoom = multiplier;
            zoomer.style.cursor = multiplier === 2 ? 'zoom-out' : 'zoom-in';
            initZoom();
        };
    }
}
